import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import dayjs from "dayjs";
export var LanguageOptions = [{
        Language: 'English',
        DisplayName: 'English'
    }, {
        DisplayName: "हिन्दी",
        Language: 'Hindi'
    }, {
        DisplayName: "मराठी",
        Language: 'Marathi'
    }, {
        DisplayName: "తెలుగు",
        Language: 'Telugu'
    }, {
        DisplayName: "தமிழ்",
        Language: 'Tamil'
    }, {
        DisplayName: "ಕನ್ನಡ",
        Language: 'Kannada'
    }, {
        DisplayName: "ગુજરાતી",
        Language: 'Gujarati'
    }, {
        DisplayName: "മലയാളം",
        Language: 'Malayalam'
    }];
export var LeadStageOptions = [{
        id: 0,
        Name: 'Service',
        Status: 0
    }, {
        id: 1,
        Name: 'AMC',
        Status: 1
    }, {
        id: 2,
        Name: 'Insurance',
        Status: -1
    }, {
        id: 3,
        Name: 'Ex. warranty',
        Status: 2
    }, {
        id: 4,
        Name: 'RSA',
        Status: 0
    }];
export var LeadStageStatusOptions = ['Opened', 'In progress', 'Closed'];
export var undueColumns = [{
        field: 'Particulars',
        // service due, cross sell due / overdue service, overdue cross sell (negative)
        headerName: '',
        align: 'right',
        headerAlign: 'right',
        minWidth: 180
    }, {
        type: 'number',
        field: '30',
        headerName: '+30 days',
        flex: 1
    }, {
        type: 'number',
        field: '20',
        headerName: '+20 days',
        flex: 1
    }, {
        type: 'number',
        field: '10',
        headerName: '+10 days',
        flex: 1
    }, {
        type: 'number',
        field: '3',
        headerName: '+3 days',
        flex: 1
    }, {
        type: 'number',
        field: '1',
        headerName: '+1 days',
        flex: 1
    }];
export var overdueColumns = [{
        field: 'Particulars',
        // service due, cross sell due / overdue service, overdue cross sell (negative)
        headerName: '',
        align: 'right',
        headerAlign: 'right',
        minWidth: 180
    }, {
        type: 'number',
        field: '30',
        headerName: '-30 days',
        flex: 1
    }, {
        type: 'number',
        field: '20',
        headerName: '-20 days',
        flex: 1
    }, {
        type: 'number',
        field: '10',
        headerName: '-10 days',
        flex: 1
    }, {
        type: 'number',
        field: '3',
        headerName: '-3 days',
        flex: 1
    }, {
        type: 'number',
        field: '1',
        headerName: '-1 days',
        flex: 1
    }];
export var LeadsRowData = [{
        id: 'total',
        Particulars: "Total due"
    }, {
        id: 'calls',
        Particulars: "Calls done"
    }, {
        id: 'appointments',
        Particulars: "Appointments scheduled"
    }, {
        id: 'conversion',
        Particulars: "Conversion %"
    }];
export var TotalCalls = {
    ServiceDue: {
        1: 20,
        3: 54,
        10: 137,
        20: 346,
        30: 639
    },
    CrossSell: {
        1: 39,
        3: 95,
        10: 337,
        20: 742,
        30: 946
    },
    OverdueService: {
        1: 7,
        3: 24,
        10: 94,
        20: 168,
        30: 382
    },
    OverdueCross: {
        1: 14,
        3: 36,
        10: 158,
        20: 247,
        30: 358
    }
};
export var ConversionRate = Object.entries(TotalCalls).reduce(function (acc, _ref) {
    var key = _ref[0], val = _ref[1];
    acc[key] = {
        1: Math.random(),
        3: Math.random(),
        10: Math.random(),
        20: Math.random(),
        30: Math.random()
    };
    return acc;
}, {});
export var CrossSellFilters = ['AMC', 'EW', 'RSA', 'Insurance'].map(function (key) { return ({
    Name: key
}); });
export var ServiceDueFilters = ['Free Service', 'Schedule Maintenance', 'Waranty Services', 'Repairs', 'Other Services'].map(function (key) { return ({
    Name: key
}); });
export var UpcomingSlots = [{
        "timeslots": {
            "9:00 - 12:00 pm": 4,
            "12:00 - 2:00 pm": 8,
            "3:00 - 5:00 pm": 6,
            "5:00 - 7:00 pm": 2
        },
        "total_appointments": 20,
        "workshop_capacity": 30
    }, {
        "timeslots": {
            "9:00 - 12:00 pm": 5,
            "12:00 - 2:00 pm": 9,
            "3:00 - 5:00 pm": 7,
            "5:00 - 7:00 pm": 4
        },
        "total_appointments": 25,
        "workshop_capacity": 30
    }, {
        "timeslots": {
            "9:00 - 12:00 pm": 6,
            "12:00 - 2:00 pm": 3,
            "3:00 - 5:00 pm": 4,
            "5:00 - 7:00 pm": 5
        },
        "total_appointments": 18,
        "workshop_capacity": 30
    }, {
        "timeslots": {
            "9:00 - 12:00 pm": 7,
            "12:00 - 2:00 pm": 9,
            "3:00 - 5:00 pm": 8,
            "5:00 - 7:00 pm": 12
        },
        "total_appointments": 36,
        "workshop_capacity": 32
    }, {
        "timeslots": {
            "9:00 - 12:00 pm": 5,
            "12:00 - 2:00 pm": 11,
            "3:00 - 5:00 pm": 7,
            "5:00 - 7:00 pm": 9
        },
        "total_appointments": 32,
        "workshop_capacity": 35
    }, {
        "timeslots": {
            "9:00 - 12:00 pm": 3,
            "12:00 - 2:00 pm": 6,
            "3:00 - 5:00 pm": 3,
            "5:00 - 7:00 pm": 5
        },
        "total_appointments": 17,
        "workshop_capacity": 35
    }, {
        "timeslots": {
            "9:00 - 12:00 pm": 1,
            "12:00 - 2:00 pm": 2,
            "3:00 - 5:00 pm": 1,
            "5:00 - 7:00 pm": 6
        },
        "total_appointments": 10,
        "workshop_capacity": 32
    }].map(function (obj, i) { return _objectSpread(_objectSpread({}, obj), {}, {
    date: dayjs().add(i, 'days').format('D MMM')
}); });
export var ServiceDetailsFilters = [{
        Name: "High risk & paid service",
        filters: ['high', 'paid']
    }, {
        Name: "High risk & service is due this month",
        filters: ['high', 'Jan']
    }, {
        Name: "High risk & calls attempted",
        filters: ['high', 'Follow up']
    }, {
        Name: "High risk & AMC expiring",
        filters: ['high', 'amc']
    }];
